<template>
    <section class="container-fluid px-0">
        <div :class="appLayout.tab" class="nav-tabs-custom m-0" role="tabpanel">
            <!-- Nav tabs -->
            <!-- <ul class="nav nav-tabs" role="tablist">
                <li class="active">
                    <a href="#tabFormulario" class="py-2" role="tab" data-toggle="tab">
                        <i class="fa fa-shopping-cart"></i>
                        Carrinho
                    </a>
                </li>
            </ul> -->
            <div class="tab-content py-0">
                <div class="tab-pane active" id="tabFormulario">
                    <div class="row justify-content-around my-3 mx-0">
                        <div class="col-12 col-md-8 py-2 shadow">
                            <div class="row justify-content-center">
                                <span class="smalltext"><strong>Assinatura </strong> </span>
                            </div>
                            <div class="row align-items-center">
                                <div class="validade col-md-8 offset-md-2 mb-5">
                                    <div :style="{'z-index: 0;':(dados.adicionais.length)}" class="row">
                                        <template v-for="(validade, i) in validades">
                                            <div :class="{'selected': validadeSelect==i}" class="col-3 text-center"
                                                :key="validade.id" @click="validadeSelect=i">
                                                <p class="m-0"> {{ validade.nome }} </p>
                                                <p class="smallText m-0"> {{ validade.vencimento }} dias</p>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <p class="smallText m-0">Clique para adicionar</p>
                            </div>
                            <div class="row justify-content-center">
                                <div :class="(modulosValidos() >= 2) ? 'col-12 col-md-8' : 'col-12' " class="my-2">
                                    <div class="row justify-content-around align-items-center">
                                        <div v-for="modulo in modulos" :key="modulo.id" @click="addItem(modulo)"
                                            class="modulos col text-center" v-show="modulo.tipo == 'ADICIONAL'">
                                            <div class="titulo text-center">
                                                <div> <i :class="modulo.icon" class="fa fa-2x"></i> </div>
                                                <span class="smallText px-2" style="vertical-align: top;">1x </span>
                                                {{modulo.descricao}}
                                            </div>
                                            <div class="valor text-center">
                                                <span class="smallText" style="vertical-align: top;">R$ </span>
                                                {{ (total(modulo.valor)).toFixed(2).replace('.',',') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr class="my-4">
                            <!--
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label>Valor Unit.</label>
                                        <money disabled v-model="moduloAdicional.valor" class="form-control"></money>
                                    </div>
                                </div>
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Módulo</label>
                                        <select @change="getModuloAdicionalValue()" v-model="moduloAdicional.id"
                                            class="form-control">
                                            <option :value="null">{{$t('words.select')}}</option>
                                            <option v-for="item in modulos" :key="item.id" :value="item.id"
                                                v-show="item.valor > 0 && dados.adicionais.findIndex(x => x.id == item.id)==-1">
                                                {{item.descricao}} - {{formatMoney(item.valor)}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <required /> <label> Validade</label>
                                        <div class="input-group">
                                            <select @change="getModuloAdicionalValue()"
                                                v-model="moduloAdicional.fk_validade_id" class="form-control">
                                                <option :value="null">{{$t('words.select')}}</option>
                                                <option v-for="item in validades" :key="item.id" :value="item.id">
                                                    {{item.nome}} - {{item.vencimento}}</option>
                                            </select>
                                            <span class="input-group-btn">
                                                <button @click="addItem"
                                                    :disabled="!moduloAdicional.fk_validade_id || !moduloAdicional.id"
                                                    class="btn" :class="appLayout.btn">
                                                    <i class="fa fa-cart-plus"></i>
                                                    {{$t('words.add')}}
                                                </button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             -->
                            <div class="row justify-content-center ">
                                <div class="col-11 col-lg-8 callout-x alert-light">
                                    <card-form ref="TabPayment" :payment="dados" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 pt-2 shadow">
                            <p class="lead text-center"><strong>Resumo</strong></p>
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Produto</th>
                                        <th>Qtd</th>
                                        <th>Vencimento</th>
                                        <th>Subtotal</th>
                                    </tr>
                                </thead>
                                <tbody v-if="(dados.adicionais.length)">
                                    <tr v-for="(item, i) in dados.adicionais" :key="i">
                                        <td>
                                            <a href="#" @click="removeItem(item, i)">
                                                <i class="fa fa-trash text-red"></i>
                                            </a>
                                        </td>
                                        <td>{{item.descricao}}</td>
                                        <td class="d-flex justify-content-around py-4">
                                            <a href="#" @click="changeItem(item,'decrement')">
                                                <i v-show="item.quantidade > 1" class="fa fa-minus"></i>
                                            </a>
                                            <span class="px-2">{{item.quantidade}}</span>
                                            <a href="#" @click="changeItem(item,'increment')"><i
                                                    class="fa fa-plus"></i></a>
                                        </td>
                                        <td>{{formatDate(item.vencimento)}}</td>
                                        <td>{{formatMoney(item.valor*item.quantidade)}}</td>
                                    </tr>
                                </tbody>
                                <td v-else class="smallText text-center py-2" colspan="5">Selecione um adicional </td>
                            </table>
                            <div class="table-responsive">
                                <table class="table">
                                    <tbody>
                                        <tr>
                                            <th style="width:50%">Subtotal:</th>
                                            <td class="text-right">{{formatMoney(dados.total)}}</td>
                                        </tr>
                                        <tr>
                                            <th>Desconto</th>
                                            <td class="text-right">R$ 0,00</td>
                                        </tr>
                                        <tr>
                                            <th>Total:</th>
                                            <td class="text-right">{{formatMoney(dados.total)}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <button @click="send()" :disabled="loading" type="button"
                                            class="btn btn-success float-right">
                                            <i class="fa fa-credit-card"></i>
                                            Confirmar Pagamento <i v-show="loading"
                                                class="fa fa-circle-o-notch fa-spin"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import CardForm from '../home/components/card-form.vue';
    export default {
        components: {
            CardForm
        },
        name: 'store',
        data() {
            return {
                // moduloAdicional: {
                //     quantidade: 1,
                //     tipo: null,
                //     valor: 0,
                //     vencimento: null,
                //     default: false,
                //     fk_validade_id: null,
                //     id: null,
                // },
                loading: false,
                dados: {
                    total: 0,
                    cardName: "",
                    cardNumber: "",
                    cardMonth: null,
                    cardYear: null,
                    cardCvv: "",
                    grecaptcha: "",
                    adicionais: [],
                },
                validades: {},
                validadeSelect: 0,
            };
        },
        computed: {
            modulos() {
                return this.$store.state.planoModulo.select;
            },
        },
        watch: {
            $route(data) {
                if (data.name != 'loja')
                    this.$destroy();
            },
        },
        beforeMount() {},
        mounted() {
            this.$store.dispatch('getAllPlanoModulo');
            this.$store.dispatch('getEmpresaPlano', this.empresaLogada.id)
                .then(response => {
                    this.validades = response.validades;
                });

            console.log('dados', this.dados);
            console.log('adicionais', this.validades);
        },
        methods: {
            // getModuloAdicionalValue() {
            //     let date = this.validades.find(validade => validade.id == this.moduloAdicional.fk_validade_id);
            //     let modulo = this.modulos.find(modulo => modulo.id == this.moduloAdicional.id);
            //     if (date && modulo) {
            //         this.moduloAdicional.tipo = modulo.nome;
            //         this.moduloAdicional.descricao = modulo.descricao;
            //         this.moduloAdicional.title = modulo.nome;
            //         this.moduloAdicional.valor = modulo.valor;
            //         this.moduloAdicional.valor = modulo.valor * parseInt((date.vencimento / 30));
            //         this.moduloAdicional.vencimento = new Date(new Date().setDate(new Date().getDate() +
            //             date.vencimento)).toISOString().substring(0, 10)
            //     }
            // },
            addItem(payload) {
                // this.dados.adicionais.push(_.cloneDeep(this.moduloAdicional));
                let clone = _.cloneDeep(payload);
                clone.fk_validade_id = (this.validades[this.validadeSelect].id);
                clone.title = payload.nome;
                clone.tipo = payload.nome;
                clone.vencimento = new Date(new Date().setDate(new Date().getDate() +
                    this.validades[this.validadeSelect].vencimento)).toISOString().substring(0, 10)
                clone.valor = clone.valor * parseInt((this.validades[this.validadeSelect].vencimento) / 30);

                let has = this.dados.adicionais.find(d => d.id == clone.id);
                if (has)
                    this.dados.adicionais.map(d => {
                        if (d.id == clone.id) {
                            d.quantidade++;
                            d.vencimento = clone.vencimento;
                            d.valor = clone.valor;
                        }
                    });
                else {
                    clone.quantidade = 1;
                    this.dados.adicionais.push(_.cloneDeep(clone));
                }
                // this.moduloAdicional.id = null;
                // this.moduloAdicional.valor = 0;
                // this.moduloAdicional.fk_validade_id = null;
                // this.moduloAdicional.id = null;
                this.setValueFinal();
            },
            changeItem(item, type) {
                if (type == 'increment') item.quantidade++;
                if (type == 'decrement' && item.quantidade > 1) item.quantidade--;
                this.setValueFinal();
            },
            removeItem(item, i) {
                this.dados.adicionais.splice(i, 1);
                this.setValueFinal();
            },
            setValueFinal() {
                this.dados.total = 0;
                this.dados.adicionais.map(item => {
                    this.dados.total += parseFloat(item.valor) * parseInt(item.quantidade);
                });
            },
            total(payload) {
                if (this.validadeSelect == 0) return payload * 1;
                else if (this.validadeSelect == 1) return payload * 3;
                else if (this.validadeSelect == 2) return payload * 6;
                else if (this.validadeSelect == 3) return payload * 12;
            },
            modulosValidos() {
                let count = 0;
                this.modulos.map(m => {
                    if (m.tipo == 'ADICIONAL') count++;
                })
                return count;
            },
            validatePayment() {
                return this.$refs.TabPayment.validate();
            },
            selectRecorrencia(payload) {
                if (this.$refs.wizard) {
                    //this.$refs.wizard.changeTab(1, 2);
                }
            },
            choicePlan(payload) {
                this.$store.commit('SET_PLANO_SELECTED', payload);
            },
            async send() {
                let valid = await this.validatePayment();
                if (!valid) {
                    return
                }
                if (!this.dados.adicionais.length) {
                    toastr({
                        icon: 'error',
                        title: 'Adicione um Item!'
                    });
                    return;
                }
                this.dados.grecaptcha = await this.$recaptcha("AdicinaisPayment")
                    .then(token => {
                        return token;
                    });
                this.dados.tokenId = this.$route.params.tokenId;
                this.loading = true;
                this.$store.dispatch('adquirirAdicional', this.dados)
                    .then(response => {
                        this.loading = false;
                        console.log(response);
                        toastr({
                            title: response.message,
                            icon: response.status,
                        });
                        if (response.status != 'success') return
                        this.$router.push('/home');
                    })
            },
        }
    };
</script>

<style scoped src="@/assets/sass/bootstrap4.css"></style>
<style scoped>
    .nav-tabs-custom {
        box-shadow: none;
    }

    .tab-pane .shadow {
        box-shadow: 0 0 .5px .2px #888;
        /* border: 1px solid dimgray; */
        border-radius: 5px;
    }


    .validade {
        color: #4464d8;
        border: 2px solid rgb(40, 130, 200);
        border-radius: 5px;
        background-color: transparent;
        cursor: pointer;
        transition: all 0.3s;
    }

    .validade .selected {
        background-color: rgb(40, 130, 200);
        color: white;
    }

    .validade p:not(.smallText) {
        font-weight: 600;
    }

    .smallText {
        font-size: small;
    }

    .modulos .titulo {
        color: white;
        padding: 10px 0;
        font-size: 20px;
        font-weight: 600;
        cursor: pointer;
        border-radius: 5px 5px 0 0;
        background-color: rgb(40, 130, 200);
    }

    .modulos .valor {
        color: #0074d9;
        padding: 5px 0;
        width: 90%;
        font-size: 25px;
        cursor: pointer;
        border-radius: 5px;
        background-color: white;
        margin-top: -10px;
        margin-left: auto;
        margin-right: auto;
        box-shadow: 0 1.5px 4px rgb(0 0 0 / 24%), 0 1.5px 6px rgb(0 0 0 / 12%);
    }

    td {
        vertical-align: middle !important;
    }

    @media screen and (min-width: 1024px) {
        .tab-pane .shadow {
            max-width: 62% !important;
        }
    }
</style>
<style>
    .card-item {
        -webkit-transform: scale(0.9, 0.7) !important;
        transform: scale(0.9, 0.7) !important;
    }

    .card-item__number {
        display: flex !important;
    }

    .card-item__numberItem {
        width: 14px !important;
    }
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
    .errPage-container {
        width: 800px;
        margin: 50px auto;

        .pan-back-btn {
            background: #008489;
            color: #fff;
            border: none !important;
        }

        .pan-gif {
            margin: 0 auto;
            display: block;
        }

        .pan-img {
            display: block;
            margin: 0 auto;
            width: 100%;
        }

        .text-jumbo {
            font-size: 60px;
            font-weight: 700;
            color: #484848;
        }

        .list-unstyled {
            font-size: 14px;

            li {
                padding-bottom: 5px;
            }
        }
    }
</style>